const state = {
	isUserLoggedIn: false,
	userAuthInfo: {},
	categories: [],
	isEmailVerified: false,
	isUserActivated: false,
	isAlertModalOpen: false,
	isLoginModalOpen: false,
	isLoginSelectionModalOpen: false,
	isSignupSelectionModalOpen: false,
	isForgetPasswordModalOpen:false,
}

export default state